import {
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import { useState } from "react";
import Modal from "../../User/components/Modal";
import Grid from "@mui/material/Grid2";
// import ImageUpload from "./ImageUpload";
import upload from "../../User/assets/upload-design.svg";
import { styled } from "@mui/system";
import instance from "../../Utils/api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import NumberInput from "../components/NumberInput.jsx";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import { useGlobalContext } from "../../context/Context.js";
import Login from "../components/Login.jsx";



const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  box-sizing: border-box;
  width: 100%;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${theme.palette.mode === "dark" ? grey[900] : grey[50]
    };

  &:hover {
    border-color: #e37b00;
  }

  &:focus {
    border-color: #e37b00;
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

const YesFabricPopup = ({
  isYesFabric,
  handleYesFabricCloseModal,
  add_to_cart,
}) => {
  const [size, setSize] = useState("");
  const [orderFor, setOrderFor] = useState("");
  const [fabric, setFabric] = useState("");
  const [procure, setProcure] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const token = localStorage.getItem("token");
  const { id } = useParams();
  const [previewImages, setPreviewImages] = useState([]);
  const { SetCartItem } = useGlobalContext()
  const [loading, setLoading] = useState(false)
  const [addCart, setAddCart] = useState({
    fabric: "",
    size: "",
    orderFor: "",
    quantity: 1,
    fabricimg: [],
    procure: ""
  })

  const [errors, setErrors] = useState({
    size: "",
    fabric: "",
    procure: "",
    fabricimg: "",
    orderFor: "",
    quantity: ""
  });

  const handlecartFabricImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 4) {
      toast.error("You can upload a maximum of 4 images.");
      e.target.value = null;
      return;
    }
    setAddCart({
      ...addCart,
      fabricimg: files,
    });
    setErrors((prev) => ({
      ...prev,
      fabricimg: "",
    }));
  };

  const handleCloseLoginModal = () => {
    setLoginModalOpen(false);
  };

  const handleLoginSuccess = () => {
    setLoginModalOpen(false);
    handleAddtoCartcustom();
  };

  const handleAddtoCart = async () => {
    if (!token) {
      setLoginModalOpen(true);
      return;
    }
    let tempErrors = {};

    if (!addCart.size) tempErrors.size = "Please select a size";
    if (!addCart.fabric) tempErrors.fabric = "Please select fabric option";
    if (addCart.fabric === "No" && !addCart.procure)
      tempErrors.procure = "Please select an option";
    if (addCart.fabric === "Yes" && addCart.fabricimg.length === 0)
      tempErrors.fabricimg = "Please upload fabric image(s)";
    if (!addCart.orderFor) tempErrors.orderFor = "Please mention who this order is for";
    if (!addCart.quantity || addCart.quantity < 1)
      tempErrors.quantity = "Enter a valid quantity";

    setErrors(tempErrors);

    // stop submission if any error exists
    if (Object.keys(tempErrors).length > 0) return;
    try {
      setLoading(true);
      const formData = new FormData();
      const item = {
        design_kind: "Design",
        fabric_given: addCart.fabric === "Yes" ? true : false,
        size: addCart.size,
        quantity: addCart.quantity,
        design_id: id,
        ordered_for: addCart.orderFor,
        procure: addCart?.procure === "Yes" ? true : false
      };
      formData.append("item", JSON.stringify(item));

      if (addCart.fabricimg && addCart.fabricimg.length) {
        addCart.fabricimg.forEach((file) => {
          formData.append("fabric_img", file);
        });
      }
      const response = await instance.patch("/Cart/addToCart", formData);
      if (response.data.success === true) {
        handleYesFabricCloseModal();
        toast.success(response.data.message || "Added to Cart");
        setAddCart({ fabric: "", size: "", orderFor: "", quantity: 1, fabricimg: [], procure: "" });
        // Trigger cart length update
        SetCartItem(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  //custom design
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    setCustomDesign({
      ...customdesign,
      picture: files,
    });

    setCustomdesignErrors((prev) => ({
      ...prev,
      picture: "",
    }));
    const previews = files.map((file) => {
      return URL.createObjectURL(file);
    });
    setPreviewImages(previews);
  };

  const handleFabricImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Max files
    if (files.length > 4) {
      toast.error("You can upload a maximum of 4 files.");
      e.target.value = null;
      return;
    }

    for (let file of files) {

      // Allow ALL image formats
      const isImage = file.type.startsWith("image/");

      // Allow ALL PDFs (MIME or extension fallback)
      const isPDF =
        file.type === "application/pdf" ||
        file.name.toLowerCase().endsWith(".pdf");

      // Block EVERYTHING else
      if (!isImage && !isPDF) {
        toast.error("Only image files and PDF files are allowed.");
        e.target.value = null;
        return;
      }
    }

    setCustomDesign({
      ...customdesign,
      fabric_img: files,
    });
    setCustomdesignErrors((prev) => ({
      ...prev,
      fabric_img: "",
    }));
  };

  const [customdesign, setCustomDesign] = useState({
    size: "",
    fabric: "",
    quantity: 1,
    description: "",
    ordered_for: "",
    picture: [],
    procure: "",
    name: ""
  });
  const [customdesignErrors, setCustomdesignErrors] = useState({});

  const validateCustomDesign = () => {
    let errors = {};

    if (!customdesign.size) errors.size = "Please select a size";
    if (!customdesign.fabric) errors.fabric = "Please select if you have fabric";

    if (customdesign.fabric === "Yes") {
      if (!customdesign.fabric_img || customdesign.fabric_img.length === 0) {
        errors.fabric_img = "Please upload fabric image";
      }
    }

    if (customdesign.fabric === "No") {
      if (!customdesign.procure) {
        errors.procure = "Please select procure option";
      }
    }

    if (!customdesign.quantity) errors.quantity = "Please select a quantity";

    if (!customdesign.picture.length)
      errors.picture = "Please upload at least one design";

    if (!customdesign.ordered_for)
      errors.ordered_for = "Please enter who this order is for";

    if (!customdesign.name) errors.name = "Please enter your name";

    if (!customdesign.description)
      errors.description = "Please enter description";

    setCustomdesignErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddtoCartcustom = async () => {
    if (!token) {
      setLoginModalOpen(true);
      return;
    }
    if (!validateCustomDesign()) return;
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("size", customdesign?.size);
      formData.append("fabric_given", customdesign?.fabric === 'Yes' ? true : false);
      formData.append("design_kind", "CustomDesign");
      formData.append("quantity", customdesign?.quantity);
      formData.append("description", customdesign?.description);
      formData.append("name", customdesign?.name);
      formData.append("ordered_for", customdesign?.ordered_for);
      formData.append("procure", customdesign?.procure === 'Yes' ? true : false);
      customdesign.picture.forEach((file) => formData.append("picture", file));
      if (customdesign.fabric_img && customdesign.fabric_img.length) {
        customdesign.fabric_img.forEach((file) => {
          formData.append("fabric_img", file);
        });
      }


      const response = await instance.post(
        "/Catalogue/addCustomDesign",
        formData
      );

      if (response.data.success === true) {
        handleYesFabricCloseModal();
        toast.success( "Added to Cart");
        // toast.success(response.data.message || "Added to Cart");
        setPreviewImages([]);
        setCustomDesign({
          size: "",
          fabric: null,
          quantity: 1,
          description: "",
          order_for: "",
          picture: [],
          procure: "",
          name: ""
        });
        SetCartItem(true);

      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const closeUploadPopup = () => {
    handleYesFabricCloseModal();
    setPreviewImages([]);
    setSize("");
    setFabric("");
    setOrderFor("");
    setCustomDesign({
      size: "",
      fabric: null,
      quantity: 1,
      description: "",
      order_for: "",
      picture: [],
      name: ""
    });
    setAddCart({
      fabric: "",
      size: "",
      orderFor: "",
      quantity: 1,
      fabricimg: [],
      procure: ""
    })
    setCustomdesignErrors({});
  };

  return (
    <>
      <Modal isOpen={isYesFabric} onClose={closeUploadPopup}>
        {add_to_cart === true ? (
          <section className="confitmation-yes">
            <div className="confitmation-yes-content">
              <div className="confitmation-yes-title">
                <Typography variant="h4">Add to Cart</Typography>
                <Typography variant="h5">Provide your details</Typography>
              </div>
              <div className="confitmation-yes-input">
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label8">
                          Size
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Size"
                          value={addCart?.size}
                          onChange={(e) => {
                            setAddCart({
                              ...addCart,
                              size: e.target.value,
                            });
                            setErrors({ ...errors, size: "" });
                          }}
                          error={!!errors.size}
                        >
                          <MenuItem value="S">S</MenuItem>
                          <MenuItem value="M">M</MenuItem>
                          <MenuItem value="L">L</MenuItem>
                          <MenuItem value="XL">XL</MenuItem>
                          <MenuItem value="XXL">XXL</MenuItem>
                          <MenuItem value="XXXL">XXXL</MenuItem>
                        </Select>
                        <FormHelperText error>{errors.size}</FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label10">
                          Do you have fabric?
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select10"
                          label="Do you have fabric?"
                          value={addCart?.fabric}
                          onChange={(e) => {
                            setAddCart({
                              ...addCart,
                              fabric: e.target.value,
                            });
                            setErrors({ ...errors, fabric: "" });
                          }}
                          error={!!errors.fabric}
                        >
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText error>{errors.fabric}</FormHelperText>
                    </div>
                  </Grid>
                  {addCart.fabric === "No" &&
                    <>
                      <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                        <div className="admin-textfiled">
                          <FormControl fullWidth required>
                            <InputLabel id="demo-simple-select-label">
                              Do you want us to Procure ?
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Do you want us to Procure ?"
                              value={addCart.procure}
                              onChange={(e) => {
                                setAddCart({
                                  ...addCart,
                                  procure: e.target.value,
                                });
                                setErrors({ ...errors, procure: "" });
                              }}
                              error={!!errors.procure}
                            >
                              <MenuItem value="Yes">Yes</MenuItem>
                              <MenuItem value="No">No</MenuItem>
                            </Select>
                            <FormHelperText error>{errors.procure}</FormHelperText>

                          </FormControl>
                        </div>
                      </Grid>
                    </>
                  }
                  {addCart.fabric === "Yes" &&
                    <>
                      <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                        <div className="admin-textfiled">
                          <TextField
                            type="file"
                            label="Upload Fabric *"
                            accept="image/*"
                            multiple
                            InputLabelProps={{ shrink: true }}
                            // inputProps={{ multiple: true }}
                            onChange={handlecartFabricImageChange}
                            inputProps={{ accept: "image/*", multiple: true }}
                            error={!!errors.fabricimg}
                          />
                          <FormHelperText error>{errors.fabricimg}</FormHelperText>
                        </div>

                      </Grid>
                    </>
                  }
                  {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">
                          order for
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Order For"
                          value={addCart.orderFor}
                          onChange={(e) => {
                            setAddCart({
                              ...addCart,
                              orderFor: e.target.value,
                            });
                          }}
                        >
                          <MenuItem value="myself">myself</MenuItem>
                          <MenuItem value="family">family</MenuItem>
                          <MenuItem value="friends">friends</MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Grid> */}
                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <TextField
                          label="Order For *"
                          variant="outlined"
                          value={addCart.orderFor}
                          onChange={(e) => {
                            setAddCart({
                              ...addCart,
                              orderFor: e.target.value,
                            });
                            setErrors({ ...errors, orderFor: "" });
                          }}
                          helperText={errors.orderFor}
                          error={!!errors.orderFor}
                        />
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <InputLabel id="demo-simple-select-label1">
                        Enter Quantity
                      </InputLabel>
                      <NumberInput
                        label="Quantity"
                        required
                        labelId="demo-simple-select-label1"
                        value={addCart.quantity}
                        onChange={(event, newValue) => {
                          if (newValue >= 1 && newValue <= 100) {
                            setAddCart({ ...addCart, quantity: newValue });
                            setErrors({ ...errors, quantity: "" });
                          }
                        }}
                        min={1}
                        max={100}
                      />
                    </div>
                    <FormHelperText error>{errors.quantity}</FormHelperText>
                  </Grid>
                </Grid>
              </div>
              <div className="confitmation-yes-uploadfile">
                <Button onClick={handleAddtoCart} disabled={loading}>
                  {loading ? (
                    <CircularProgress size={24} color="#fff" />
                  ) : (
                    "Add to cart"
                  )}
                </Button>
              </div>
            </div>
          </section>
        ) : (
          <section className="confitmation-yes">
            <div className="confitmation-yes-content">
              <div className="confitmation-yes-title">
                <Typography variant="h4">Upload Your Design</Typography>
                <Typography variant="h5">Provide your details</Typography>
              </div>
              <div className="confitmation-yes-input">
                <Grid container spacing={1}>
                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">
                          Size
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={customdesign?.size}
                          label="Size"
                          required
                          onChange={(e) => {
                            setCustomDesign({
                              ...customdesign,
                              size: e.target.value,
                            });
                            setCustomdesignErrors((prev) => ({ ...prev, size: "" }));
                          }}
                          error={!!customdesignErrors.size}
                        >
                          <MenuItem value="S">S</MenuItem>
                          <MenuItem value="M">M</MenuItem>
                          <MenuItem value="L">L</MenuItem>
                          <MenuItem value="XL">XL</MenuItem>
                          <MenuItem value="XXL">XXL</MenuItem>
                          <MenuItem value="XXXL">XXXL</MenuItem>
                        </Select>
                        <FormHelperText error>{customdesignErrors.size}</FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <FormControl fullWidth required>
                        <InputLabel id="demo-simple-select-label">
                          Do you have fabric?
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={customdesign?.fabric}
                          label="Do you have fabric?"
                          required
                          onChange={(e) => {
                            setCustomDesign({
                              ...customdesign,
                              fabric: e.target.value,
                            });
                            setCustomdesignErrors((prev) => ({ ...prev, fabric: "" }));
                          }}
                          error={!!customdesignErrors.fabric}
                        >
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                        <FormHelperText error>{customdesignErrors.fabric}</FormHelperText>
                      </FormControl>
                    </div>
                  </Grid>

                  {customdesign.fabric === "Yes" &&
                    <>
                      <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                        <TextField
                          type="file"
                          label="Upload Fabric"
                          accept="image/*,.pdf"
                          InputLabelProps={{ shrink: true }}
                          inputProps={{ accept: "image/*", multiple: true }}
                          onChange={handleFabricImageChange}
                          error={Boolean(customdesignErrors.fabric_img)}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "8px",
                              ...(customdesignErrors.fabric_img && {
                                "& fieldset": {
                                  borderColor: "red !important",
                                },
                              }),
                            },
                          }}
                        />
                        <FormHelperText error>{customdesignErrors.fabric_img}</FormHelperText>
                      </Grid>
                    </>
                  }

                  {customdesign.fabric === "No" &&
                    <>
                      <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                        <div className="admin-textfiled">
                          <FormControl fullWidth required>
                            <InputLabel id="demo-simple-select-label">
                              Do you want us to Procure ?
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={customdesign?.procure}
                              label="Do you want us to Procure ?"
                              required
                              onChange={(e) => {
                                setCustomDesign({
                                  ...customdesign,
                                  procure: e.target.value,
                                });
                                setCustomdesignErrors((prev) => ({ ...prev, procure: "" }));
                              }}
                            >
                              <MenuItem value="Yes">Yes</MenuItem>
                              <MenuItem value="No">No</MenuItem>
                            </Select>
                            <FormHelperText error>{customdesignErrors.procure}</FormHelperText>
                          </FormControl>
                        </div>
                      </Grid>
                    </>
                  }
                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <TextField
                        aria-label="minimum height"
                        value={customdesign?.ordered_for}
                        required
                        label="Order For"
                        placeholder="Enter order for"
                        onChange={(e) => {
                          setCustomDesign({
                            ...customdesign,
                            ordered_for: e.target.value,
                          });
                          setCustomdesignErrors((prev) => ({ ...prev, ordered_for: "" }));
                        }}
                        error={!!customdesignErrors.ordered_for}
                        helperText={customdesignErrors.ordered_for}
                      />
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <TextField
                        id="outlined-basic"
                        label="Design Name"
                        variant="outlined"
                        required
                        onChange={(e) => {
                          setCustomDesign({
                            ...customdesign,
                            name: e.target.value,
                          });
                          setCustomdesignErrors((prev) => ({ ...prev, name: "" }));
                        }}
                        error={!!customdesignErrors.name}
                        helperText={customdesignErrors.name}
                      />
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <InputLabel id="demo-simple-select-label1">
                        Enter Quantity *
                      </InputLabel>
                      <NumberInput
                        label="Quantity"
                        id="demo-simple-select-label1"
                        value={customdesign?.quantity}
                        onChange={(event, newValue) => {
                          if (newValue >= 1 && newValue <= 100) {
                            setCustomDesign({
                              ...customdesign,
                              quantity: newValue,
                            });
                          }
                        }}
                        min={1}
                        max={100}
                      />
                    </div>
                  </Grid>

                  <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                    <div className="admin-textfiled">
                      <Typography sx={{ fontSize: 15, color: "#8a8a8a", fontFamily: "Poppins sans-serif" }}> Description *</Typography>
                      <Textarea
                        required
                        aria-label="minimum height"
                        minRows={4}
                        placeholder="Description"
                        value={customdesign?.description}
                        onChange={(e) => {
                          setCustomDesign({
                            ...customdesign,
                            description: e.target.value,
                          });
                          setCustomdesignErrors((prev) => ({ ...prev, description: "" }));
                        }}
                        style={{ borderColor: customdesignErrors.description ? "red" : "" }}
                      />
                      {customdesignErrors.description && (
                        <Typography style={{ color: "red", fontSize: "12px" }}>
                          {customdesignErrors.description}
                        </Typography>
                      )}
                    </div>
                  </Grid>


                  <Grid item size={{ xs: 12, sm: 6, md: 12, lg: 12 }}>
                    <div className='upload-image-preview'>
                      <div className='file-upload-image'>
                        <Typography variant='h5'> Upload your designs *</Typography>
                        <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                          <img src={upload} alt="upload" width={200} />
                        </label>
                        <input
                          id="file-upload"
                          type="file"
                          multiple
                          accept="image/*"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                      </div>

                    </div>
                    {customdesignErrors.picture && (
                      <Typography style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
                        {customdesignErrors.picture}
                      </Typography>
                    )}
                  </Grid>

                  {previewImages.length > 0 && (
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                      <div className="categoryimage-preview">
                        <ul
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "10px",
                            padding: 0,
                            marginBottom: "10px",
                          }}
                        >
                          {previewImages.map((img, index) => (
                            <li
                              key={index}
                              style={{
                                position: "relative",
                                listStyle: "none",
                                display: "inline-block",
                              }}
                            >
                              <img
                                src={img}
                                alt={`Design ${index}`}
                                width={150}
                                height={150}
                                style={{
                                  borderRadius: "8px",
                                  objectFit: "cover",
                                  border: "1px solid #ddd",
                                }}
                              />

                              <Button
                                onClick={() => {
                                  const updatedPreviews = previewImages.filter((_, i) => i !== index);
                                  const updatedFiles = customdesign.picture.filter((_, i) => i !== index);
                                  setPreviewImages(updatedPreviews);
                                  setCustomDesign({ ...customdesign, picture: updatedFiles });
                                }}
                                sx={{
                                  position: "absolute",
                                  top: "-8px",
                                  right: "-8px",
                                  minWidth: "auto",
                                  backgroundColor: "white",
                                  borderRadius: "50%",
                                  boxShadow: "0px 0px 4px rgba(0,0,0,0.3)",
                                  color: "red",
                                  "&:hover": { backgroundColor: "#fff" },
                                }}
                              >
                                ✕
                              </Button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </Grid>
                  )}
                </Grid>

              </div>

              <div className="confitmation-yes-uploadfile">
                <Button onClick={handleAddtoCartcustom} disabled={loading}>
                  {loading ? (
                    <CircularProgress size={24} color="#fff" />
                  ) : (
                    "Add to cart"
                  )}
                </Button>
              </div>
            </div>

          </section>
        )}
      </Modal>
      {isLoginModalOpen && (
        <Login
          isLoginModalOpen={isLoginModalOpen}
          handleCloseLoginModal={handleCloseLoginModal}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default YesFabricPopup;
